/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Upgrade_After_TeamInputs */



/**
* | output |
* | --- |
* | "After upgrade (Team)" |
*
* @param {Sub_Upgrade_After_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_upgrade_after_team = /** @type {((inputs?: Sub_Upgrade_After_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Upgrade_After_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Upgrade (Team)")
	return /** @type {LocalizedString} */ ("After upgrade (Team)")
});